import { atom, useAtom } from "jotai"

type CartState = "toaster" | "cart" | "cross-sell"

const cartStateAtom = atom<CartState>("cart")

export function useCartState() {
  return useAtom(cartStateAtom)
}
